import { create } from 'zustand'

const usePdfStore = create((set) => ({
  isExcel: false,
  selectedIds: [],
  selectedComponentIds: [],
  actions: {
    setIsExcel: (isExcel) => set({ isExcel }),
    setSelectedIds: (selectedIds) => set({ selectedIds }),
    setSelectedComponentIds: (selectedComponentIds) => set({ selectedComponentIds })
  }
}))

export const usePDFisExcel = () => usePdfStore((state) => state.isExcel)
export const usePDFselectedIds = () => usePdfStore((state) => state.selectedIds)
export const usePDFselectedComponentIds = () => usePdfStore((state) => state.selectedComponentIds)

export const usePdfStoreActions = () => usePdfStore((state) => state.actions)
